import * as React from 'react';
import { StyledDatePicker, StyledFormSelect, StyledFormGroup, Button, StyledToggle } from '../../';

export const ApplicationDatePicker = (props: any) => (
  <StyledDatePicker {...props} mr={[0, 4]} flex={['1 0 100%', '1 0 48%', '1 0 23%']} />
);

export const ApplicationFormSelect = (props: any) => (
  <StyledFormSelect {...props} mr={[0, 4]} flex={['1 0 100%', '1 0 48%', '1 0 23%']} />
);

export const ApplicationFormGroup = (props: any) => (
  <StyledFormGroup {...props} flex={['1 0 100%', '1 0 48%', '1 0 23%']} mr={props.noMargin ? 0 : [0, 4]} />
);

export const ApplicationButton = (props: any) => (
  <Button {...props} mr={props.noMargin ? 0 : [0, 0, 2]} mb={[2, 2, 0]} width={['100%', 'auto']} type="button" />
);

export const ModalButton = (props: any) => (
  <Button {...props} size="sm" type="button" width="auto" mr={props.noMargin ? 0 : 2} outline={true} />
);

export const ApplicationToggle = (props: any) => (
  <StyledToggle {...props} mr={[0, 4]} flex={['1 0 100%', '1 0 48%', '1 0 23%']} />
);



// WEBPACK FOOTER //
// ./src/components/formElements/applicationFormElements/index.tsx